export default "__VITE_ASSET__ClPuQcWs__"